// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconAddress: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18">
            <path
                fill="currentColor"
                d="M9.70263 16.66629a20.82487 20.82487 0 0 1-1.6317-2.1079c-.95363-1.41837-1.52378-2.68819-1.52378-3.68626 0-1.86027 1.54536-3.37262 3.44373-3.37262 1.89075 0 3.43611 1.51108 3.44373 3.37135.00508.99934-.56506 2.26916-1.52377 3.68754a20.70798 20.70798 0 0 1-1.6406 2.10789h6.87223V6.6665H2.85707v9.99978h6.84556Zm-7.79791 0V6.6665h-.39364C.6768 6.66651 0 5.91986 0 4.99925c0-.17777.0254-.35555.07746-.52697l1.00823-3.33326C1.29139.45967 1.86916 0 2.52058 0h14.95839c.65014 0 1.22917.45967 1.43488 1.13902l1.00823 3.33326c.26412.87363-.16507 1.8171-.95743 2.10789a1.3841 1.3841 0 0 1-.47745.08634h-.39238v9.99978h1.42854c.26299 0 .47618.21319.47618.47618 0 .26298-.21319.47617-.47618.47617H.47618c-.26299 0-.47618-.21319-.47618-.47617 0-.263.2132-.47618.47618-.47618h1.42854ZM2.47359.95236c-.2184 0-.41141.16507-.48125.40634L.97776 4.93195a.6897.6897 0 0 0-.0254.18793c0 .33015.2273.59555.50792.59555h17.07898a.43936.43936 0 0 0 .16127-.03048c.26666-.10413.40887-.44063.31999-.753L18.0072 1.36124c-.06984-.2438-.26285-.40761-.48253-.40761H2.47486L2.4736.95236Zm7.52618 10.95213c-.52597 0-.95236-.42639-.95236-.95236s.42639-.95236.95236-.95236.95236.42639.95236.95236-.42639.95236-.95236.95236Zm-.0127 3.85007c1.48568-1.77266 2.6374-3.62404 2.63234-4.87989-.00763-1.4171-1.18602-2.57137-2.62853-2.57137-1.44885 0-2.62724 1.153-2.62724 2.56883 0 1.25712 1.14664 3.10977 2.62343 4.88243Z"
            />
        </svg>
    );
};

export default React.memo(IconAddress);
